(function () {
  'use strict';

  const TEMPLATE_SELECTOR = '[data-video-template]';
  const LOADING_CLASS = 'is-loading';
  const ATTR_VIDEO_ID = 'data-video-id';
  const ATTR_AUTOPLAY = 'data-autoplay';

  if (customElements.get('video-background')) return;

  customElements.define(
    'video-background',
    class VideoBackground extends HTMLElement {
      constructor() {
        super();
        this.videoTemplateObserver = null;
        this.videoPlayObserver = null;
      }

      connectedCallback() {
        this.videoId = this.getAttribute(ATTR_VIDEO_ID);
        this.videoTemplate = this.querySelector(TEMPLATE_SELECTOR);
        this.video = null;
        this.autoplay = this.getAttribute(ATTR_AUTOPLAY) !== 'false';
        this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);
        if (this.videoId) {
          this.renderVideo();
        }
      }

      powerSaverVideoPlay() {
        this.video?.play();
      }

      renderVideo() {
        this.videoTemplateObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const html = this.videoTemplate.innerHTML;
              this.innerHTML = html;
              this.classList.remove(LOADING_CLASS);
              this.video = this.querySelector('video');
              this.observeVideoPlayToggle();

              if (this.autoplay && this.video) {
                this.video
                  .play()
                  .then(() => {})
                  .catch(() => {
                    document.addEventListener('click', this.powerSaverVideoPlay, {
                      passive: true,
                      bubbles: true,
                      once: true,
                    });
                    document.addEventListener('touchstart', this.powerSaverVideoPlay, {
                      passive: true,
                      bubbles: true,
                      once: true,
                    });
                  });
              }

              this.initPlayOverlay();

              observer.unobserve(entry.target);
            });
          },
          {
            root: null,
            rootMargin: '300px',
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
          }
        );

        this.videoTemplateObserver.observe(this);
      }

      initPlayOverlay() {
        const root = this.closest('.video-background');
        const btn = root?.querySelector('[data-video-play-overlay]');
        if (!btn || !this.video) return;

        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          root.classList.add('is-playing');
          btn.classList.add('video-background__play-btn--hidden');
          btn.setAttribute('aria-hidden', 'true');
        };

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.video.play().catch(() => {});
        });

        this.video.addEventListener('playing', finish, { once: true });
      }

      observeVideoPlayToggle() {
        if (!this.video) return;

        this.videoPlayObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const visible = entry.isIntersecting;

              if (visible && this.autoplay && typeof this.video.play === 'function') {
                const p = this.video.play();
                if (p !== undefined) {
                  p.then(() => {}).catch(() => {});
                }
              } else if (!visible && typeof this.video.pause === 'function') {
                this.video.pause();
              }
            });
          },
          { rootMargin: '0px', threshold: [0, 1] }
        );

        this.videoPlayObserver.observe(this.video);
      }

      disconnectedCallback() {
        this.videoTemplateObserver?.disconnect();
        this.videoPlayObserver?.disconnect();
        if (this.videoId) {
          document.removeEventListener('click', this.powerSaverVideoPlay);
          document.removeEventListener('touchstart', this.powerSaverVideoPlay);
        }
      }
    }
  );
})();
